module.exports = fox._r("fonts/mc-icons-webfont.woff", __webpack_public_path__ + "_/_/_/common/frame/fonts/25SICGq.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/mc-icons-webfont.woff
// module id = 144
// module chunks = 2